module.exports = __webpack_public_path__ + "static/channels-2-a4650aa7217b36b3e77dce14a7583229.svg";